import { API } from "aws-amplify";
import logger from "./logger";

const analytics = {
  metrics: {
    products: {
      vista: 1,
      venta: 2
    }
  },
  products: async (products, metric) => {
    try {
      const promises = [];

      for (let i = 0; i < products.length; i++) {
        const product = products[i];

        const init = {
          body: {
            product,
            metric
          }
        };

        const promise = API.put("carritofacilapi", "/analytics/products", init);

        promises.push(promise);
      }

      await Promise.all(promises);
    } catch (err) {
      logger("analytics.products.error", err);
    }
  }
};

export default analytics;
